// extracted by mini-css-extract-plugin
export default {"SearchPanel":"pi_a bhh_ea bhh_kb bhh_js bhh_a bhh_j bhh_sm bhh_sn","SearchPanel__icon":"pi_b bhh_vm bhh_hg bhh_ss bhh_uy","SearchPanel__input":"pi_c bhh_iz bhh_eb bhh_z"};